import Vue from 'vue'
import VueRouter from 'vue-router'
import loginTemp from '@/cview/login/login.vue'
import loginTemps from '@/cview/login/logintmp.vue'
import registerTemp from '@/cview/login/register.vue'
import Index from '@/view/index.vue'
import courseTemp from '@/cview/course/index.vue'
import coursesTemp from '@/cview/course/myindex.vue'
import examinationTemp from '@/cview/examination/index.vue'
import orderTemp from '@/cview/order/index.vue'
import certificateTemp from '@/cview/certificate/index.vue'
import userTemp from '@/cview/user/index.vue'
import showTemp from '@/cview/news/show.vue'
import listTemp from '@/cview/news/list.vue'
import videoTemp from '@/cview/course/myvideo.vue'
import videosTemp from '@/cview/course/myvideos.vue'
import ExamTemp from '@/cview/examination/Exam.vue'
import succTemp from '@/cview/examination/succ.vue'

Vue.use(VueRouter)
const routes = [{
		path: '/',
		name: 'login',
		redirect: '/login'
	}, {
		path: '/login',
		name: 'login',
		component: loginTemp,
	}, {
		path: '/logins',
		name: 'logins',
		component: loginTemps,
	},
	{
		path: '/register',
		name: 'register',
		component: registerTemp,
	},
	{
		path: '/list',
		name: 'list',
		component: listTemp,
	},
	{
		path: '/show',
		name: 'show',
		component: showTemp,
	},
	{
		path: '/video',
		name: 'video',
		component: videoTemp,
	},
	{
		path: '/videos',
		name: 'videos',
		component: videosTemp,
	},
	{
		path: '/Exam',
		name: 'Exam',
		component: ExamTemp,
	},
	{
		path: '/succ',
		name: 'succ',
		component: succTemp,
	},
	{
		path: '/index',
		name: 'index',
		component: Index,
		children: [{
				path: '/course',
				name: 'courseTemp',
				component: courseTemp
			},
			{
				path: '/courses',
				name: 'coursesTemp',
				component: coursesTemp
			},
			{
				path: '/examination',
				name: 'examinationTemp',
				component: examinationTemp
			},
			{
				path: '/order',
				name: 'orderTemp',
				component: orderTemp
			},
			{
				path: '/certificate',
				name: 'certificateTemp',
				component: certificateTemp
			},
			{
				path: '/user',
				name: 'userTemp',
				component: userTemp
			},
		]
	}
]

const router = new VueRouter({
	routes
})
// 挂载路由守卫（前置守卫）
router.beforeEach((to, from, next) => {
	console.log(to);
	const token = sessionStorage.getItem('token')
	const userInfos = JSON.parse(sessionStorage.getItem('userInfo'))

	const pageList = [
		'/login',
		'/logins',
		'/list',
		'/show',
		'/register'
	];
	// if (userInfos) {
	// 	if (userInfos.hasOwnProperty('is_changepass')) {
	// 		if (userInfos.is_changepass === 0) {
	// 			next('/course')
	// 		}
	// 	} else {
	// 		sessionStorage.clear()
	// 	}
	// }

	/*if (pageList.indexOf(to.path) === -1 && !token) {
		next('/login')
	} else if (!token && pageList.indexOf(to.path) === 1) {
		next('/login')
	} else {
		next()
	}*/


	if (!token && to.path !== '/login' && to.path !== '/logins' && to.path !== '/list' && to.path !==
		'/show' && to.path !== '/register') {
		next('/login') // 如果没有token且不是访问登录页面，则重定向到登录页面
	} else {
		next() // 否则放行
	}
})
export default router
